import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { StntReport } from './report.types';
import { persist } from 'zustand/middleware';

interface StntsReport {
    usage: string; // 1, 2, 3
    targetId: number;
}

interface ReportState {
    stntReport: StntReport;
    stntsReport: StntsReport;
    setStntReport: (report: Partial<StntReport>) => void;
    setStntsReport: (report: Partial<StntsReport>) => void;
    resetAll: () => void;
}

export const useReportStore = create<ReportState>()(
    persist(
        immer((set) => ({
            stntReport: {
                publishTab: 'URL', // 리포트 뱃지
                stntId: undefined,
                setsId: undefined,
                nickname: undefined,
                usage: undefined,
                targetId: undefined,
                mainTab: '상세 보기',
                subTab: 'contents',
                thumbListIdx: 0,
                stntsListIdx: undefined,
                claId: '',
                textbkId: 0,
            },
            stntsReport: {
                usage: '',
                targetId: 0,
            },
            setStntReport: (report) =>
                set((state) => {
                    Object.assign(state.stntReport, report);
                }),
            setStntsReport: (report) =>
                set((state) => {
                    Object.assign(state.stntsReport, report);
                }),
            resetAll: () =>
                set((state) => {
                    state.stntReport = {
                        publishTab: 'URL',
                        stntId: undefined,
                        setsId: undefined,
                        nickname: undefined,
                        usage: undefined,
                        targetId: 0,
                        mainTab: '상세 보기',
                        subTab: 'contents',
                        thumbListIdx: 0,
                        stntsListIdx: undefined,
                        claId: '',
                        textbkId: 0,
                    };
                    state.stntsReport = {
                        usage: '',
                        targetId: 0,
                    };
                }),
        })),
        {
            name: 'report-storage', // 세션 스토리지에 저장될 key
            partialize: (state) => ({
                stntReport: state.stntReport,
                stntsReport: state.stntsReport,
            }),
        }
    )
);
